import * as React from 'react';
import * as SeparatorPrimitive from '@radix-ui/react-separator';
import { Separator as ShadcnSeparator } from '@/hen-ui/shadcn/separator';

export type SeparatorProps = React.ComponentPropsWithoutRef<
  typeof SeparatorPrimitive.Root
>;

export const Separator: React.FC<SeparatorProps> = ({
  className,
  decorative = true,
  ...otherProps
}) => (
  <ShadcnSeparator
    className={className}
    decorative={decorative}
    role='separator'
    {...otherProps}
  />
);
